import { createLucideIcon } from "lucide-react";
const TableRowsIcon = createLucideIcon("TableRowsIcon", [
  ["rect", { key: "rect", x: "3", y: "3", width: "18", height: "18" }],
  ["line", { key: "line1", x1: "3", x2: "21", y1: "9", y2: "9" }],
  ["line", { key: "line2", x1: "3", x2: "21", y1: "15", y2: "15" }]
]);
const TableColumnsIcon = createLucideIcon("TableColumnsIcon", [
  ["rect", { key: "rect", x: "3", y: "3", width: "18", height: "18" }],
  ["line", { key: "line1", x1: "9", x2: "9", y1: "3", y2: "21" }],
  ["line", { key: "line2", x1: "15", x2: "15", y1: "3", y2: "21" }]
]);
export {
  TableColumnsIcon,
  TableRowsIcon
};
//# sourceMappingURL=index.js.map
